// extracted by mini-css-extract-plugin
export default {"section":"Xs-z","sectionTitle":"Ys-z","fieldWrapper":"Zs-z","formField":"_s-z","disabled":"at-z","formLabel":"bt-z"};